<script>
import Onboarding from "../../components/onboarding/Onboarding.vue";
import ForgotPasswordForm from '../../components/form/ForgotPasswordForm.vue';

export default {
  components: { Onboarding, ForgotPasswordForm },
  computed: {
    isMobileScreen() {
      return window.innerWidth < 768;
    },
  },
  methods: {
    async doRedefine() {
      try {
        const { company_label } = this.$router.history.current.params;

        this.$vs.loading({
          text: "Enviando...",
        });

        const response = await this.$http.post("api/v1/forget/password", {
          email: this.email,
          label: company_label,
        });

        if (response.status === 200) {
          this.message = response.data["message"];
          this.sended = true;
          this.$vs.loading.close();
        }
      } catch (error) {
        this.$vs.loading.close();

        this.$vs.notify({
          title: "Falha ao redefinir senha",
          text:
            error.message ||
            "Falha ao realizar o procedimento contate a nossa equipe de suporte",
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "danger",
        });
      }
    },
    handleRedirectToSignIn() {
      const { query, params } = this.$router.history.current;

      this.$router.push({
        name: "signin",
        params,
        query,
      });
    },
  },
};
</script>

<template>
  <div v-if="!isMobileScreen" class="forgot-password">
    <div class="forgot-password__letfside bg-primary-opacity">
      <onboarding />
    </div>
    <div class="forgot-password__rightside">
      <forgot-password-form />
    </div>
  </div>
  <div v-else class="forgot-password">
    <div class="forgot-password__mobile--wrapper">
      <forgot-password-form />
    </div>
  </div>
</template>

<style lang="scss" scoped>
.forgot-password {
  display: flex;
  width: 100%;
  height: 100vh;

  &__letfside {
    display: flex;
    align-items: center;
    justify-content: center;
    flex: 1;
    width: 100%;
    height: 100%;
  }

  &__rightside {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    max-height: 100vh;
    min-width: 440px;
    padding: 0 40px;
  }

  &__mobile--wrapper {
    display: flex;
    flex-direction: column;
    margin: 0 auto;
    padding: 8px;
    align-self: center;
    justify-self: center;
  }

  &__mobile--wrapper > button {
    margin: 22px 13px;

    @media (max-width: 599px) {
      margin: 15px 13px;
    }
  }

  &__mobile--wrapper > p {
    font-family: "Roboto", sans-serif;
    font-size: 14px;
    text-align: center;
  }
}
</style>
